import $ from 'jquery';

(function ($) {
    $.fn.sortable = function () {
        return this.each(function () {
            const $element = $(this);
            const sortAttribute = $element.data('sort-attribute');

            if (sortAttribute) {
                $element.on('click', function () {
                    var el = $(this);

                    const currentSortOrderMatch = el.attr('uk-filter-control')?.match(/order: (asc|desc)/);
                    const currentSortOrder = currentSortOrderMatch ? currentSortOrderMatch[1] : 'asc';
                    const newSortOrder = currentSortOrder === 'desc' ? 'asc' : 'desc';

                    el.attr('uk-filter-control', `sort: ${sortAttribute}; order: ${newSortOrder}`);
                    el.removeClass('uk-active');
                });
            }
        });
    };
})($);
